import { type FC } from 'react'

import { NavigationText, TagText } from '@/components/core'
import { ChevronDownStrokeIcon } from '@/components/core/Icon/icons'
import { SIDEBAR_TEST_IDS } from '@/constants/testIds'

import { getOrganizationInitials } from './utils'

interface OrganizationSelectorProps {
  organizationName: string
  isOpen: boolean
  isCollapsed: boolean
  onClick: () => void
}

export const OrganizationSelector: FC<OrganizationSelectorProps> = ({
  organizationName,
  isOpen,
  isCollapsed,
  onClick,
}) => {
  const initials = getOrganizationInitials(organizationName)

  return (
    <button
      className="sidebar__org-selector"
      onClick={onClick}
      aria-expanded={isOpen}
      aria-label={`Current organization: ${organizationName}. Click to switch organizations`}
      title={isCollapsed ? organizationName : undefined}
      data-testid={SIDEBAR_TEST_IDS.ORGANIZATION_SELECTOR}
    >
      <div className="sidebar__org-avatar">
        <TagText>{initials}</TagText>
      </div>
      {!isCollapsed && (
        <>
          <NavigationText className="sidebar__org-name">{organizationName}</NavigationText>
          <ChevronDownStrokeIcon className={`sidebar__org-arrow ${isOpen ? 'sidebar__org-arrow--open' : ''}`} />
        </>
      )}
    </button>
  )
}
